export const data = {
    upComing: {
        tokenSaleHero: {
            bg: {
                img: "/img/token-sale-bg.webp",
                width: 1440,
                height: 800,
            },
            applyBtn: {
                show: true,
                disable: true,
            },
            content: {
                layout: "upcoming",
                lb1: "stay tune",
                lb2: "The whitelist is not open yet",
            },
            countdown: {
                // Fetch from API
                // from: new Date(),
                // to: new Date(new Date().getTime()+(10*24*60*60*1000)),
                // from: 1645297909691,
                // to: 1665297909691,
                introLb: "",
                displayFromTo: false,
                tba: false,
            },
            completedStep: 1,
        },
    },
    whitelistOpen: {
        tokenSaleHero: {
            bg: {
                img: "/img/token-sale-bg.webp",
                width: 1440,
                height: 800,
            },
            applyBtn: {
                show: true,
                disable: false,
            },
            content: {
                layout: "whitelist-open",
                lb1: "whitelist opens",
                lb2: "The whitelist is now open. Your turn!",
            },
            countdown: {
                // from & to: Fetch from API
                // from: 1645297909691,
                // to: 1665297909691,
                introLb: "End to join whitelist in",
                displayFromTo: true,
                tba: false,
            },
            completedStep: 2,
        },
    },
    whitelistWin: {
        tokenSaleHero: {
            bg: {
                img: "/img/token-sale-bg.webp",
                width: 1440,
                height: 800,
            },
            applyBtn: {
                show: false,
                disable: false,
            },
            whitelistResult: {
                // Data from API
                // price: "$50 BUSD",
                totalWinner: {
                    title: "Total winner",
                    // Data from API
                    // value: 750,
                },
                checkDetails: {
                    title: "Check winner list",
                    // Data from API
                    // link: "https://www.google.com/intl/vi_VN/forms/about/",
                    target: "_blank",
                },
            },
            content: {
                layout: "whitelist-win",
                lb0: "Congratulation!",
                lb1: "you win whitelist",
                lb2: "Congrats! Your Guaranteed allocation for this pod is",
            },
            countdown: {
                // from & to: Fetch from API
                // from: 1645297909691,
                // to: 1665297909691,
                introLb: "Swap will be started in",
                displayFromTo: false,
                tba: true,
            },
            completedStep: 2,
        },
    },
    whitelistFail: {
        tokenSaleHero: {
            bg: {
                img: "/img/token-sale-bg.webp",
                width: 1440,
                height: 800,
            },
            applyBtn: {
                show: false,
                disable: false,
            },
            whitelistResult: {
                totalWinner: {
                    title: "Total winner",
                    // Data from API
                    // value: 750,
                },
                checkDetails: {
                    title: "Details",
                    // Data from API
                    // link: "https://www.google.com/intl/vi_VN/forms/about/",
                    target: "_blank",
                },
            },
            content: {
                layout: "whitelist-fail",
                lb0: "We are sorry !",
                lb1: "just a bad luck !",
                lb2: "Unfortunately, you didn’t win a guaranteed allocation for this pool. However, you still can join FCFS Phase if there is any token left from  Phase 1",
            },
            completedStep: 2,
        },
    },
    whitelistApplied: {
        tokenSaleHero: {
            bg: {
                img: "/img/token-sale-bg.webp",
                width: 1440,
                height: 800,
            },
            applyBtn: {
                show: false,
                disable: false,
            },
            content: {
                layout: "whitelist-applied",
                lb1: "applied whitelist",
                lb2: "Allocation Result will be announced on Thursday, Dec 16, 2022",
            },
            countdown: {
                // from & to: Fetch from API
                // from: 1645297909691,
                // to: 1665297909691,
                introLb: "You will see your result in",
                displayFromTo: false,
                tba: false,
            },
            completedStep: 2,
        },
    },
    whitelistClose: {
        tokenSaleHero: {
            bg: {
                img: "/img/token-sale-bg.webp",
                width: 1440,
                height: 800,
            },
            applyBtn: {
                show: false,
                disable: false,
            },
            whitelistResult: {
                totalWinner: {
                    title: "Total winner",
                    // Data from API
                    // value: 750,
                },
                checkDetails: {
                    title: "Check winner list",
                    // Data from API
                    // link: "https://www.google.com/intl/vi_VN/forms/about/",
                    target: "_blank",
                },
            },
            content: {
                layout: "whitelist-close",
                lb1: "whitelist closed",
                lb2: "Allocation Result will be announced on ", // Thursday, Dec 16, 2022
            },
            countdown: {
                // from & to: Fetch from API
                // from: 1645297909691,
                // to: 1665297909691,
                introLb: "You will see your result in",
                displayFromTo: false,
                tba: false,
            },
            completedStep: 2,
        },
    },
    whitelistCloseNoAuth: {
        tokenSaleHero: {
            bg: {
                img: "/img/token-sale-bg.webp",
                width: 1440,
                height: 800,
            },
            applyBtn: {
                show: false,
                disable: false,
            },
            whitelistResult: {
                // Data from API
                // price: "$50 BUSD",
                totalWinner: {
                    title: "Total winner",
                    // Data from API
                    // value: 750,
                },
                checkDetails: {
                    title: "Check winner list",
                    // Data from API
                    // link: "https://www.google.com/intl/vi_VN/forms/about/",
                    target: "_blank",
                },
            },
            content: {
                layout: "whitelist-close",
                lb1: "whitelist closed",
                lb2: "Congratulations to all winners. Please connect wallet to check details",
            },
            countdown: {
                // from & to: Fetch from API
                // from: 1645297909691,
                // to: 1665297909691,
                introLb: "Swap will be started in",
                displayFromTo: false,
                tba: true,
            },
            completedStep: 2,
        },
    },
    tokenPurchase: {
        tokenSaleHero: {
            bg: {
                img: "/img/token-sale-bg.webp",
                width: 1440,
                height: 800,
            },
            content: {
                layout: "token-purchase",
                lb1: "buy token...",
                lb2: "Buying in progress and will be done",
            },
            progressBar: {
                title: "Buy Token...",
                loadingBar: {
                    token: {
                        img: "/img/mdn-token@3x.webp",
                        width: 135,
                        height: 147,
                    },
                    fire: {
                        img: "/img/fire@3x.webp",
                        width: 347,
                        height: 59,
                    },
                },
                // currentProgress: "10",
                // totalAllocation: "40,000,000",
                // soldAllocation: "20,000,000",
                // tokenSymbol: "MDN",
            },
            countdown: {
                // from & to: Fetch from API
                // from: 1645297909691,
                // to: 1665297909691,
                introLb: "",
                displayFromTo: false,
                tba: false,
            },
            completedStep: 3,
            purchaseForm: {
                whitelistWin: true,
                // demandBalance: "10,000",
                currency: "BUSD",
                approveBtn: {
                    display: true,
                    disable: false,
                    label: "approve",
                    remindDesc:
                        "You need to approve once (and only once) before you can start swapping",
                },
                purchaseBtn: {
                    display: false,
                    disable: false,
                    label: "purchase",
                    remindDesc:
                        "Before Purchasing, please check your balance (Sale Price + GAS Fee)",
                },
                estimatedReceiveMDN: {
                    title: "You will get approximately",
                    // value: "666,666",
                    currency: "MDN",
                },
            },
        },
    },
    tokenPurchaseSuccess: {
        tokenSaleHero: {
            bg: {
                img: "/img/token-sale-bg.webp",
                width: 1440,
                height: 800,
            },
            content: {
                layout: "token-purchase",
                lb1: "buy token...",
                lb2: "Buying in progress and will be done",
            },
            progressBar: {
                title: "Buy Token...",
                loadingBar: {
                    token: {
                        img: "/img/mdn-token@3x.webp",
                        width: 60,
                        height: 64,
                    },
                    fire: {
                        img: "/img/fire@3x.webp",
                        width: 347,
                        height: 59,
                    },
                },
                // Fetch from API
                // currentProgress: "80",
                // totalAllocation: "40,000,000",
                // soldAllocation: "20,000,000",
                // tokenSymbol: "MDN",
            },
            countdown: {
                // from & to: Fetch from API
                // from: 1645297909691,
                // to: 1665297909691,
                introLb: "",
                displayFromTo: false,
                tba: false,
            },
            completedStep: 3,
            purchaseSuccess: {
                title: "congratulation!",
                desc: "You have successfully bought in this Seed round",
                details: [
                    // Detail get form API
                    // {
                    //     title: "Transaction ID",
                    //     value: "0x713563a8F783b993758d94e5E735bEc3Ae2CBD92",
                    //     type: "tx",
                    //     link: "https://bscscan.com",
                    //     target: "_blank",
                    // },
                    // {
                    //     title: "Your contribution",
                    //     value: "10,000 BUSD",
                    // },
                    // {
                    //     title: "Token rate",
                    //     value: "0,015 BUSD",
                    // },
                    // {
                    //     title: "Estimate Allocation",
                    //     value: "4,000,000 MDN",
                    // },
                ],
                distribution: {
                    tba: true,
                    title: "Distribute time: ",
                    // time: "TBA",
                },
            },
        },
    },
    tokenPurchaseClose: {
        tokenSaleHero: {
            bg: {
                img: "/img/token-sale-bg.webp",
                width: 1440,
                height: 800,
            },
            content: {
                layout: "token-purchase-close",
                lb1: "Seed Round Closed",
            },
            vestingSchedule: {
                title: "vesting schedule",
                schedule: {
                    headers: {
                        date: "date",
                        percent: "%",
                        amount: "amount (MDN)",
                    },
                    rows: [],
                },
                paging: {
                    // total: 28,
                    // current: 1,
                    itemsPerPage: 7,
                },
            },
            completedStep: 4,
        },
    },
};
